<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">
              <i class="fa fa-cloud-download mr-2"></i>
              Centro de Descargas - CentralGym
            </h4>
            <p class="card-category">
              Últimas versiones disponibles del sistema
            </p>
          </div>
          <div class="card-body">
            <!-- Mock Data Banner -->
            <div v-if="useMockData" class="alert alert-info mb-4">
              <h6><i class="fa fa-code mr-2"></i>Modo Simulado Activo</h6>
              <p class="mb-0">
                VUE_APP_UPDATECENTER=0 - Los datos mostrados son simulados y las descargas no funcionarán.
                Para usar el servidor real de actualizaciones, configura VUE_APP_UPDATECENTER=1.
              </p>
            </div>

            <!-- Loading State -->
            <div v-if="loading" class="text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Cargando...</span>
              </div>
              <p class="mt-3 text-muted">Obteniendo información de las últimas versiones...</p>
            </div>

            <!-- Error State -->
            <div v-else-if="error" class="alert alert-danger">
              <h5><i class="fa fa-exclamation-triangle mr-2"></i>Error al cargar las descargas</h5>
              <p>{{ error }}</p>
              <button @click="loadReleases" class="btn btn-outline-danger btn-sm">
                <i class="fa fa-refresh mr-1"></i>
                Reintentar
              </button>
            </div>

            <!-- Content -->
            <div v-else class="row">
              <!-- CentralGym POS -->
              <div class="col-lg-6 col-md-12 mb-4">
                <div class="card shadow-sm border-0">
                  <div class="card-header bg-gradient-primary text-white">
                    <div class="d-flex align-items-center">
                      <div class="icon-big icon-shape bg-white text-primary rounded-circle mr-3">
                        <i class="fa fa-desktop"></i>
                      </div>
                      <div>
                        <h5 class="mb-0">CentralGym POS</h5>
                        <small class="opacity-8">Sistema de Punto de Venta</small>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="row mb-3">
                      <div class="col-6">
                        <div class="info-stat">
                          <label class="text-muted text-sm">Versión Actual</label>
                          <h4 class="text-primary mb-0">
                            <span class="badge badge-success badge-pill">
                              v{{ posRelease.latest }}
                            </span>
                          </h4>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="info-stat">
                          <label class="text-muted text-sm">Estado</label>
                          <div>
                            <span 
                              :class="posRelease.mandatory ? 'badge badge-danger' : 'badge badge-info'"
                              class="badge-pill"
                            >
                              {{ posRelease.mandatory ? 'Obligatoria' : 'Opcional' }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="download-options">
                      <h6 class="text-muted mb-3">Opciones de Descarga</h6>
                      
                      <!-- Instalador Completo -->
                      <div class="download-item mb-3">
                        <div class="d-flex justify-content-between align-items-center">
                          <div>
                            <h6 class="mb-1">
                              <i class="fa fa-box mr-2 text-primary"></i>
                              Instalador Completo
                            </h6>
                            <small class="text-muted">
                              Instalación completa del sistema
                            </small>
                          </div>
                          <a 
                            :href="getDownloadUrl(posRelease.installer)" 
                            @click="handleDownload('pos', 'installer', posRelease.latest, $event)"
                            class="btn btn-primary btn-sm"
                            :download="!useMockData"
                          >
                            <i class="fa fa-download mr-1"></i>
                            Descargar
                          </a>
                        </div>
                      </div>

                      <!-- Actualizador -->
                      <div v-if="posRelease.updater" class="download-item">
                        <div class="d-flex justify-content-between align-items-center">
                          <div>
                            <h6 class="mb-1">
                              <i class="fa fa-refresh mr-2 text-success"></i>
                              Actualizador
                            </h6>
                            <small class="text-muted">
                              Solo para actualizar versiones existentes
                            </small>
                          </div>
                          <a 
                            :href="getDownloadUrl(posRelease.updater)" 
                            @click="handleDownload('pos', 'updater', posRelease.latest, $event)"
                            class="btn btn-success btn-sm"
                            :download="!useMockData"
                          >
                            <i class="fa fa-download mr-1"></i>
                            Descargar
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- CentralGym ACCESS -->
              <div class="col-lg-6 col-md-12 mb-4">
                <div class="card shadow-sm border-0">
                  <div class="card-header bg-gradient-success text-white">
                                         <div class="d-flex align-items-center">
                       <div class="icon-big icon-shape bg-white text-success rounded-circle mr-3">
                         <i class="fa fa-id-card-o"></i>
                       </div>
                       <div>
                         <h5 class="mb-0">CentralGym ACCESS</h5>
                         <small class="opacity-8">Sistema de Control de Acceso</small>
                       </div>
                     </div>
                  </div>
                  <div class="card-body">
                    <div class="row mb-3">
                      <div class="col-6">
                        <div class="info-stat">
                          <label class="text-muted text-sm">Versión Actual</label>
                          <h4 class="text-success mb-0">
                            <span class="badge badge-success badge-pill">
                              v{{ accessRelease.latest }}
                            </span>
                          </h4>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="info-stat">
                          <label class="text-muted text-sm">Estado</label>
                          <div>
                            <span 
                              :class="accessRelease.mandatory ? 'badge badge-danger' : 'badge badge-info'"
                              class="badge-pill"
                            >
                              {{ accessRelease.mandatory ? 'Obligatoria' : 'Opcional' }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="download-options">
                      <h6 class="text-muted mb-3">Opciones de Descarga</h6>
                      
                      <!-- Instalador Completo -->
                      <div class="download-item mb-3">
                        <div class="d-flex justify-content-between align-items-center">
                          <div>
                            <h6 class="mb-1">
                              <i class="fa fa-box mr-2 text-success"></i>
                              Instalador Completo
                            </h6>
                            <small class="text-muted">
                              Instalación completa del sistema
                            </small>
                          </div>
                          <a 
                            :href="getDownloadUrl(accessRelease.installer)" 
                            @click="handleDownload('access', 'installer', accessRelease.latest, $event)"
                            class="btn btn-success btn-sm"
                            :download="!useMockData"
                          >
                            <i class="fa fa-download mr-1"></i>
                            Descargar
                          </a>
                        </div>
                      </div>

                      <!-- Actualizador -->
                      <div v-if="accessRelease.updater" class="download-item">
                        <div class="d-flex justify-content-between align-items-center">
                          <div>
                            <h6 class="mb-1">
                              <i class="fa fa-refresh mr-2 text-info"></i>
                              Actualizador
                            </h6>
                            <small class="text-muted">
                              Solo para actualizar versiones existentes
                            </small>
                          </div>
                          <a 
                            :href="getDownloadUrl(accessRelease.updater)" 
                            @click="handleDownload('access', 'updater', accessRelease.latest, $event)"
                            class="btn btn-info btn-sm"
                            :download="!useMockData"
                          >
                            <i class="fa fa-download mr-1"></i>
                            Descargar
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Información adicional -->
            <div v-if="!loading && !error" class="row mt-4">
              <div class="col-12">
                <div class="alert alert-info">
                  <h6><i class="fa fa-info-circle mr-2"></i>Información Importante</h6>
                  <ul class="mb-0">
                    <li>Las descargas se realizan desde un servidor seguro con cifrado SSL</li>
                    <li>Se recomienda cerrar el sistema antes de ejecutar las actualizaciones</li>
                    <li>Los instaladores completos incluyen todas las dependencias necesarias</li>
                    <li>Para soporte técnico, contacte al administrador del sistema</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import downloadService from '@/services/downloadService';

export default {
  name: 'Downloads',
  data() {
    return {
      loading: true,
      error: null,
      // Nueva variable específica para el centro de actualizaciones
      // VUE_APP_UPDATECENTER=1 → Usar servidor real updates.centralgym.app
      // VUE_APP_UPDATECENTER=0 → Usar datos mock/simulados (por defecto)
      useMockData: process.env.VUE_APP_UPDATECENTER !== '1',
      posRelease: {
        latest: '',
        mandatory: false,
        installer: '',
        updater: ''
      },
      accessRelease: {
        latest: '',
        mandatory: false,
        installer: '',
        updater: ''
      }
    };
  },
  async mounted() {
    this.$swal.close();
    await this.loadReleases();
  },
  methods: {
    async loadReleases() {
      this.loading = true;
      this.error = null;
      
      try {
        const releases = await downloadService.getAllReleases();
        
        this.posRelease = releases.pos;
        this.accessRelease = releases.access;
        
        // Mostrar notificación si hay actualizaciones obligatorias
        if (downloadService.hasMandatoryUpdates(releases)) {
          this.$swal.fire({
            title: 'Actualización Obligatoria',
            text: 'Hay actualizaciones obligatorias disponibles. Se recomienda descargar e instalar las últimas versiones.',
            icon: 'warning',
            confirmButtonText: 'Entendido'
          });
        }
        
      } catch (error) {
        console.error('Error loading releases:', error);
        
        // Manejar diferentes tipos de errores
        if (error.response && error.response.status === 401) {
          this.error = 'Sesión expirada. Por favor, inicie sesión nuevamente.';
        } else if (error.response && error.response.status === 404) {
          this.error = 'Servicio de descargas no disponible temporalmente.';
        } else if (error.code === 'NETWORK_ERROR' || error.message.includes('Network Error')) {
          this.error = 'Error de conexión. Verifique su conexión a internet y vuelva a intentar.';
        } else {
          this.error = error.message || 'No se pudo cargar la información de las descargas. Verifique su conexión a internet.';
        }
      } finally {
        this.loading = false;
      }
    },
    
    handleDownload(product, type, version, event) {
      try {
        // Registrar evento de descarga usando el servicio
        downloadService.trackDownload(product, type, version);
        
        // Si está configurado para usar datos mock, prevenir descarga real
        if (this.useMockData) {
          event.preventDefault();
          this.$swal.fire({
            title: 'Modo Simulado',
            text: `Simulando descarga de ${product} ${type} v${version}. Para usar el servidor real, configura VUE_APP_UPDATECENTER=1.`,
            icon: 'info',
            confirmButtonText: 'Entendido'
          });
          return;
        }
        
        // Mostrar notificación de éxito para servidor real
        this.$swal.fire({
          title: 'Descarga Iniciada',
          text: 'La descarga comenzará en breve. Verifique su carpeta de descargas.',
          icon: 'success',
          timer: 3000,
          showConfirmButton: false
        });
      } catch (error) {
        console.error('Error al registrar descarga:', error);
        
        // Mostrar notificación de advertencia pero permitir la descarga
        this.$swal.fire({
          title: 'Descarga Iniciada',
          text: 'La descarga comenzará en breve. (Advertencia: No se pudo registrar el evento)',
          icon: 'warning',
          timer: 3000,
          showConfirmButton: false
        });
      }
    },
    
    getDownloadUrl(url) {
      return downloadService.getDownloadUrl(url);
    }
  }
};
</script>

<style scoped>
.card {
  border: 1px solid #e3e6f0;
  transition: all 0.3s ease;
}

.card:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.bg-gradient-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 1.5rem 1.25rem;
}

.bg-gradient-success {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
  padding: 1.5rem 1.25rem;
}

.icon-big {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}

.icon-shape {
  border-radius: 50%;
}

.info-stat {
  text-align: center;
}

.info-stat label {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.download-item {
  padding: 15px;
  border: 1px solid #e3e6f0;
  border-radius: 8px;
  background: #f8f9fa;
  transition: all 0.3s ease;
}

.download-item:hover {
  background: #e9ecef;
  border-color: #dee2e6;
}

.opacity-8 {
  opacity: 0.8;
}

.text-sm {
  font-size: 0.875rem;
}

.badge-pill {
  border-radius: 10rem;
  font-size: 0.75rem;
  padding: 0.35rem 0.75rem;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}

.alert {
  border: none;
  border-radius: 10px;
}

.alert-info {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  color: #1976d2;
}

.alert-danger {
  background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);
  color: #d32f2f;
}
</style>
